<template>
  <div class="company-slide">
    <div class="company-slide-img">
      <img :src="info.image" alt="Company Slide" />
    </div>

    <div class="company-slide-info">
      <div class="company-slide-titles">
        <h2>{{ info.title }}</h2>
        <p>{{ info.title }}</p>
      </div>

      <div class="company-slide-content">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit.
          Ad aliquam a incidunt fuga, ducimus nisi iusto ipsum sit deleniti suscipit atque aliquid,
          velit at? At quasi magni voluptates molestiae aperiam
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardCompany',
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
div.company-slide {
  margin: 40px auto;
  width: 80%;
  display: flex;
  border-radius: 1px;
  overflow: hidden;
  -webkit-box-shadow: 0 0 50px -10px #666;
  box-shadow: 0 0 50px -10px #666;
  transition: all 0.5s;

  div.company-slide-img {
    width: 65%;

    img {
      width: 100%;
      height: 100% !important;
    }
  }

  div.company-slide-info {
    width: 35%;
    padding: 40px 0;

    div.company-slide-titles {
      text-align: center;
      margin-bottom: 20px;

      h2 {
        font-family: "Lucida Grande", Tahoma;
        font-size: 2em;
        margin-top: 5px;
        margin-bottom: 10px;
        font-weight: normal;
      }

      p {
        font-family: Georgia, "Times New Roman", Times, serif;
        font-size: 1em;
        font-weight: lighter;
        font-variant: normal;
        text-transform: uppercase;
        color: #666666;
        letter-spacing: 0.3em;
        margin-top: 10px;
      }
    }

    .company-slide-titles::after {
      content: "";
      display: block;
      width: 100px;
      margin: auto;
      border-top: 1px solid #76665b;
    }

    .company-slide-content {
      width: calc(100% - 40px);
      margin: 0;
      padding: 20px;
      text-align: justify;

      p {
        margin: 0;
        padding: 0;
        font-family: Georgia, "Times New Roman", Times, serif;
        font-weight: normal;
        font-size: 18px;
        line-height: 1.5em;
      }
    }
  }
}

@media screen and (max-width: 900px) {
  .company-slide {
    display: block !important;

    .company-slide-img {
      width: 100% !important;
    }
    .company-slide-info {
      width: 100% !important;
    }
  }
}
</style>
